function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 38.347,
  y: 76.587,
  width: 13.248,
  height: 73.131
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 44.971,
  cy: 76.587,
  r: 6.624
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  fill: "#333333",
  cx: 44.612,
  cy: 142.676,
  r: 23.74
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "current",
  strokeWidth: 10,
  strokeMiterlimit: 10,
  d: "M44.971,182.288 C22.931,182.288,5,164.357,5,142.317c0-13.751,6.851-26.244,18.383-33.643V26.587C23.383,14.684,33.067,5,44.971,5 s21.588,9.684,21.588,21.587v82.087c11.532,7.399,18.383,19.891,18.383,33.643C84.941,164.357,67.011,182.288,44.971,182.288z"
});

var SvgTemperature = function SvgTemperature(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "90px",
    height: "187px",
    viewBox: "0 0 90 187",
    enableBackground: "new 0 0 90 187",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemperature, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/temperature.2e43ff82.svg";
export { ForwardRef as ReactComponent };